import React, { Component } from 'react';
import { Button, notification } from 'antd';
import apiClient from '../apiClient';

class Settings extends Component {
  state = {
    exporting: false
  }

  handleExportUsers = () => {
    this.setState({ exporting: true })
    apiClient.get("/exportuserscsv")
      .then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'users.csv');
        document.body.appendChild(link);
        link.click();
      })
      .catch(error => notification.error(error))
      .finally(() => this.setState({ exporting: false }));
  }

  render() {
    const { exporting } = this.state;
    return (
      <div id="settings-index">
        <div className="container">
          <h4>Settings</h4>
          <Button loading={exporting} onClick={this.handleExportUsers} type="primary">Export Users</Button>
        </div>
      </div>
    )
  }
}

export default Settings;